import Splide from '@splidejs/splide';

export default class Slideshow {
	constructor(wrapper) {

		this.ticker 				= wrapper;
		this.track 					= this.ticker.querySelector('.promo-ticker__group');
		this.init 					= this.init.bind(this)

		new Splide(wrapper, 
		{
			type: 'loop',
			rewind: false,
			perPage: 1,
			drag: 'true',
			perMove: 1,
			autoWidth: true,
			focus: 'center',
			gap: 24,
			padding: 0,
			start: 1,
			pagination: false,
			arrows: false,
			breakpoints: {
				767: {
					gap: 8,
				},
				1024: {
					gap: 16,
				}
			}
		}).mount({
		})

	}

	init() {

		

	}
}
